module.exports = ".pointer {\n  cursor: pointer;\n}\n\n.feedback-additional-text {\n  max-width: 400px;\n  max-height: 200px;\n  overflow-y: auto;\n}\n"